// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"header_doctrine_logo-module__wrapper--n528J","hide":"header_doctrine_logo-module__hide--3qJSs"};